// App.js - Updated
import React from 'react';
import './App.css';

// Import our components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Partners from './components/Partners';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import CreatorFi from './components/CreatorFi'; // Add this import

function App() {
  return (
    <div className="App">
      {/* Accessibility: Skip to content link */}
      <a href="#services" className="skip-to-content">
        Skip to main content
      </a>

      {/* Custom Cursor */}
      <CustomCursor />

      {/* Enhanced Navigation */}
      <Navbar />

      {/* Imported Components */}
      <Hero />
      <Partners />
      <Services />
      <CaseStudies />
      <CreatorFi /> {/* Add CreatorFi section here */}
      <Testimonials />
      <Team />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;